<template lang="pug">
  div.page-layout(v-if="isLoaded")
    template(v-if="isMaintenance")
      Header2
      div.main
        router-view
      Footer2
    template(v-else)
      Header
      div.main
        router-view
      Aside
      Footer
  </template>

<script>
import { mapActions } from 'vuex'
import Header from './layout/header/Index.vue'
import Footer from './layout/footer/Index.vue'
import Header2 from './layout/header2/Index.vue'
import Footer2 from './layout/footer2/Index.vue'
import Aside from './layout/Aside.vue'

export default {
  name: 'Layout',
  data () {
    return {
      isMaintenance: false,
      isLoaded: true // 加一個 flag
    }
  },
  async mounted () {
    this.isLoaded = false
    try {
      const res = await this.getListModel({ name: 'SystemRights' })
      this.useAlternateLayout = this.shouldUseAlternateLayout(res)
      this.isMaintenance = false
    } catch (error) {
      // 進入維護模式
      this.isMaintenance = true
    } finally {
      this.isLoaded = true // API 不管成功失敗，最後都標記載入完成
    }
  },
  methods: {
    ...mapActions(['getListModel']),
    shouldUseAlternateLayout (response) {
      // 根據API返回結果決定是否使用替代佈局
      return response && response.someCondition
    }
  },
  components: {
    Header,
    Footer,
    Header2,
    Footer2,
    Aside
  }
}
</script>
